"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SessionStorage = /** @class */ (function () {
    function SessionStorage(storage) {
        this.storage = storage;
        if (!this.isSupported())
            throw new Error('Storage not supported.');
    }
    SessionStorage.prototype.isSupported = function () {
        try {
            var testKey = 'someKey';
            this.storage.setItem(testKey, testKey);
            this.storage.removeItem(testKey);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    SessionStorage.prototype.clear = function () {
        this.storage.clear();
    };
    SessionStorage.prototype.getItem = function (name) {
        return this.storage.getItem(name);
    };
    SessionStorage.prototype.key = function (index) {
        return this.storage.key(index);
    };
    SessionStorage.prototype.removeItem = function (name) {
        this.storage.removeItem(name);
    };
    SessionStorage.prototype.setItem = function (name, value) {
        this.storage.setItem(name, value);
    };
    return SessionStorage;
}());
exports.default = SessionStorage;
